import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {Contract} from '../../model/Entities/Contract';

@Component({
    selector: 'contract-delete-confirm-dialog',
    templateUrl: './contract-delete-confirm.dialog.component.html',
    styleUrls: ['./contract-delete-confirm.dialog.component.scss']
})
export class ContractDeleteConfirmDialogComponent {

    contract: Contract;

    constructor(public dialog: MatDialogRef<ContractDeleteConfirmDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any) {
        this.contract = data.contract;
    }
}



// WEBPACK FOOTER //
// /app/src/ContractsModule/ContractDeleteConfirmDialogComponent/contract-delete-confirm.dialog.component.ts